import { create } from 'zustand';
import { ApiUtils, ApplicationApi, ManualApplicationEntity, ManualApplicationSearchParams, RequestStrategyEnum } from '@shared/api';

interface ISearchManualApplicationsStore {
  loading: boolean;
  error: string | null;
  manualApplications: ManualApplicationEntity[];
  searchManualApplications: (request?: ManualApplicationSearchParams, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useSearchManualApplicationsStore = create<ISearchManualApplicationsStore>((set) => ({
  loading: false,
  error: null,
  manualApplications: [],

  searchManualApplications: ApiUtils.wrapperApi(async (request: ManualApplicationSearchParams = {}, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await ApplicationApi.searchManualApplications(request, signal);
      set({ manualApplications: result ?? [], loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ manualApplications: [], loading: false, error: null }),
}));
